<template>
  <div class="flex h-full">
    <div class="h-full p-6">
      <ImportSourceTypeMenu />
    </div>
    <div class="flex-1 h-full w-full py-6">
      <SearchesList />
    </div>
  </div>
</template>
<script setup lang="ts">
import ImportSourceTypeMenu from './SourcesList/ImportSourceTypeMenu.vue'
import SearchesList from './SearchesList/SearchesList.vue'
</script>
<style>
.flash-enter-active {
  animation: flash-background 3s;
}

@keyframes flash-background {
  0% {
    background-color: transparent;
  }

  50% {
    background: var(--color-green-100);
  }

  100% {
    background-color: transparent;
  }
}

.flash-leave-active {
  animation: fade-out-background 0.2s;
}

@keyframes fade-out-background {
  100% {
    opacity: 0;
  }
}
</style>
